<template>
  <div class="schoolCardList-container div-layout">
    <module-title title="异动记录">
      <div class="right">
        <el-button
          type="primary"
          size="medium"
          @click="_visible = false"
        >
          返回
        </el-button>
      </div>
    </module-title>
    <div class="schoolCardList-right-contain">
      <el-form
        ref="schoolCardSearchForm"
        :model="searchForm"
        :inline="true"
        label-position="right"
      >
        <el-form-item label="所属学校：" prop="schoolCode">
          <el-select v-model="searchForm.schoolCode" multiple placeholder="请选择" style="width:180px">
            <!-- <el-option label="全部" value="" /> -->
            <el-option
              v-for="item in options"
              :key="item.schoolCode"
              :label="item.name"
              :value="item.schoolCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="IMEI号：" prop="imei">
          <el-input
            v-model="searchForm.imei"
            name="imei"
            auto-complete="off"
            size="medium"
            placeholder="请输入"
            clearable
          />
        </el-form-item>

        <el-form-item style="margin-left:20px;">
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-search"
            @click="handleSearchFilter"
          >
            查询
          </el-button>
          <el-button
            type="primary"
            size="medium"
            @click="restet"
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="listLoading"
        :data="schoolCardPermissionList"
        fit
        element-loading-text="Loading"
        class="list-table"
        highlight-current-row
      >
        <el-table-column label="序号" type="index" align="center" width="55" />
        <el-table-column label="所属学校" prop="schoolName" align="center" />
        <el-table-column label="设备编号" prop="deviceNo" align="center" />
        <el-table-column label="学生卡型号" prop="deviceType" align="center" />
        <el-table-column label="学生卡IMEI号" prop="beforeImei" align="center" width="150" />
        <el-table-column label="异动时间" prop="createDate" align="center" />
        <el-table-column label="异动原因" prop="reason" align="center" width="150" />
        <el-table-column label="异动类型" align="center" width="90">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">新增学生卡</span>
            <span v-if="scope.row.type === 2">解绑学生卡</span>
            <span v-if="scope.row.type === 3">更换学生卡</span>
          </template>
        </el-table-column>
        <el-table-column label="更换后的IMEI" prop="imei" align="center" />
      </el-table>
      <pagination
        :total="searchForm.total"
        :page.sync="searchForm.pageNum"
        :limit.sync="searchForm.pageSize"
        @pagination="pageCurriculumList"
        @handleSizeChange="handleSizeChange"
      />
    </div>
  </div>
</template>

<script>
import {
  transactionList,
  schoolList
} from '@/api/systemMaintenance/devicManage/illegalCheck';
export default {
  name: 'Transaction',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      schoolCardPermissionList: [],
      searchForm: {
        imei: '',
        schoolCode: '',
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      options: [],
      listLoading: false,
      dialogVisible: false,
      flagClick: true, // 更新卡号隔5秒点击调用
      abnormalDataList: []
    };
  },
  computed: {
    // 返回
    _visible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  },
  mounted() {
    this.fetchPermissionList();
    this.getschoolList();
  },
  methods: {
    getschoolList() {
      schoolList().then(res => {
        this.options = res.data;
      });
    },
    restet() {
      this.searchForm.imei = '';
      this.searchForm.schoolCode = '';
      this.fetchPermissionList();
    },
    // selectSchool(row) {
    //   this.searchForm.schoolCode = row.toString();
    //   console.log(this.searchForm.schoolCode);
    // },
    handleCommand(command, row) {
      if (command === 'a') {
        var _self = this;
        if (_self.flagClick) {
          _self.flagClick = false;
          _self.schooleCardAuthPushDeviceNo(row);// 更新卡号
          setTimeout(function() { _self.flagClick = true; }, 1000 * 5);// 隔5秒点击调用
        }
      } else {
        this.dialogVisible = true;
      }
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchPermissionList();
    },

    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchPermissionList();
    },
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.fetchPermissionList();
    },
    // 获取列表名单
    fetchPermissionList() {
      var schoolCode = this.searchForm.schoolCode.toString();
      var option = {
        ...this.searchForm,
        schoolCode,
        type: 2
      };
      delete option.total;
      transactionList(option).then(res => {
        if (res.data && res.data.list && res.data.list.length > 0) {
          this.schoolCardPermissionList = res.data.list;
          this.searchForm.total = res.data.total;
        } else {
          this.schoolCardPermissionList = [];
        }
      });
    }

  }
};
</script>
<style lang="scss" scoped>
.schoolCardList-container {
    .edit-form-input {
      width: 6.8vw;
    }
    .textCenter{text-align: center;padding: 20px;
    .el-button {
      width: 160px;
    }

  }

  // .handle-form-input{ width: 160px;}
  // 查看详情
  .archivesTitle {
    color: #1890ff;
    font-size: 14px;
    font-weight: bold;
    padding-left: 30px;
    padding-bottom: 20px;
  }
  .marginleft-10{
    margin-left: 10px;
  }
  .red{color: red;}
  .manager-info {
    ul {
      margin-left: 60px;
      width: 50%;
      min-width: 220px;
      li {
        margin-bottom: 20px;
      }
    }
  }
}
</style>
